var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinjaPixProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NJ_icon-only_black 1",
    clipPath: "url(#clip0_4046_3227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99969 4.00037H8C6.33656 4.00037 4.85156 4.466 3.87375 5.39756C3.82968 5.34006 3.79406 5.291 3.77094 5.25381C3.62344 5.01881 3.45125 4.74318 3.32562 4.46506C3.3025 4.4135 3.28219 4.36506 3.26469 4.31943C3.37281 4.346 3.50187 4.36506 3.64125 4.356C3.77375 4.34756 3.91656 4.30193 4.04375 4.20631C4.16531 4.11506 4.23656 4.00537 4.2775 3.91756C4.35219 3.75756 4.36 3.59881 4.35906 3.50225C4.3575 3.29193 4.30719 3.046 4.24969 2.82256C4.13 2.36006 3.8925 0.685371 3.74781 0.333496L2.69062 1.96318C2.80968 2.25225 2.96187 2.66287 3.0675 3.0285C3.04281 3.0235 3.01687 3.01943 2.99031 3.016C2.89219 3.00381 2.74656 3.00068 2.585 3.05912C2.19156 3.20162 2.06281 3.55006 2.02312 3.76537C1.94156 4.21037 2.09437 4.65881 2.24312 4.9885C2.39875 5.33381 2.55437 5.46662 2.55437 5.46662L2.98281 5.961L3.24156 6.19162C3.03656 6.53193 2.87844 6.90943 2.7825 7.32943C2.56375 7.21756 2.30812 7.08662 2.08375 6.93881C2.04219 6.91131 2.00406 6.88506 1.96937 6.85975C2.05781 6.84287 2.15687 6.81412 2.24937 6.76318C2.33719 6.71475 2.41406 6.63787 2.45531 6.53193C2.49469 6.431 2.49 6.3335 2.475 6.26068C2.44781 6.12818 2.37469 6.01787 2.32625 5.95256C2.22125 5.81037 2.06469 5.65975 1.91375 5.52693C1.60187 5.25193 0.608435 4.19256 0.333435 4.00037L0.40406 5.44693C0.629685 5.60475 0.938748 5.83381 1.19312 6.04787C1.17344 6.05256 1.15343 6.05787 1.13312 6.06443C1.05906 6.08787 0.955935 6.13287 0.872498 6.22443C0.669373 6.44787 0.752185 6.72568 0.830935 6.88443C0.99406 7.21256 1.32219 7.46756 1.58875 7.64318C1.86781 7.82725 2.04187 7.86725 2.04187 7.86725L2.58437 8.06443L2.68156 8.0885C2.67594 8.186 2.66625 8.28068 2.66625 8.38162C2.66625 11.3035 5.05406 14.3335 7.99969 14.3335C10.9453 14.3335 13.3331 11.3035 13.3331 8.38162C13.3331 5.45975 10.9453 4.00037 7.99969 4.00037ZM4.29312 11.8335C4.29312 11.8335 4.29156 11.8313 4.29094 11.8304C3.49031 10.8341 3.00031 9.55193 3.00031 8.29162C3.00031 5.65193 5.15 4.3335 7.80187 4.3335C9.6075 4.3335 11.1803 4.94506 12.0003 6.1685C11.1366 5.14412 9.67906 4.63225 8.02687 4.63225C5.375 4.63225 3.22531 5.95068 3.22531 8.59037C3.22531 9.72787 3.62437 10.8835 4.29094 11.8304C4.29187 11.8313 4.2925 11.8326 4.29344 11.8335H4.29312ZM8 12.3332C5.75375 12.3332 3.58344 10.4344 3.58344 8.52537C3.58344 6.61631 5.75375 7.04006 8 7.04006C10.2462 7.04006 12.4166 6.61631 12.4166 8.52537C12.4166 10.4344 10.2462 12.3332 8 12.3332Z",
    fill: "url(#paint0_linear_4046_3227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6137 8.63994C11.8009 9.11651 11.4078 9.68463 10.7353 9.90901C10.0631 10.1331 9.36625 9.92869 9.17906 9.45182C8.99187 8.97526 9.36844 8.77807 10.0409 8.55369C10.7131 8.32932 11.4266 8.16307 11.6137 8.63994ZM4.38625 8.63994C4.19906 9.11651 4.59219 9.68463 5.26469 9.90901C5.93687 10.1331 6.63375 9.92869 6.82094 9.45182C7.00812 8.97526 6.63156 8.77807 5.95906 8.55369C5.28687 8.32932 4.57344 8.16307 4.38625 8.63994Z",
    fill: "url(#paint1_linear_4046_3227)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4046_3227",
    x1: 0.333435,
    y1: 7.3335,
    x2: 13.3331,
    y2: 7.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0A74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D57BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4046_3227",
    x1: 4.33961,
    y1: 9.16645,
    x2: 11.6604,
    y2: 9.16645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0A74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D57BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4046_3227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaPixProLogo);
export default __webpack_public_path__ + "static/media/ninja-pix-pro-logo.a2cd302769a9430f1adf03c06f25871c.svg";
export { ForwardRef as ReactComponent };